import * as React from "react"
import { OnboardingSiteType } from "@modules/onboarding/shared/types"
import { CmsIntegrationForm } from "./CmsIntegrationForm"
import { CmsProvisioningForm } from "./CmsProvisioningForm"
import { CmsVendor } from "@modules/graphql/types"

type AuthorizedFormProps = {
  siteType: OnboardingSiteType
  siteId: string
  onFinish: () => void
  orgSiteName: string
  cmsVendor: CmsVendor
  refetch?: () => void
  onFetchError: () => void
  onCancel: () => void
}

export function AuthorizedForm({
  siteType,
  siteId,
  onFinish,
  orgSiteName,
  cmsVendor,
  refetch,
  onFetchError,
  onCancel,
}: AuthorizedFormProps) {
  const onComplete = () => {
    if (refetch && typeof refetch === "function") {
      refetch()
    }

    onFinish()
    return null
  }

  if (siteType === OnboardingSiteType.Provision) {
    return (
      <CmsProvisioningForm
        siteId={siteId}
        siteName={orgSiteName}
        siteType={siteType}
        cmsVendor={cmsVendor}
        onComplete={onComplete}
        onCancel={onCancel}
        onFetchError={onFetchError}
      />
    )
  } else {
    // otherwise if it is of siteType Create or DeployNowProvision
    // we want to allow the user to select their CMS space / project
    return (
      <CmsIntegrationForm
        siteId={siteId}
        siteName={orgSiteName}
        siteType={siteType}
        cmsVendor={cmsVendor}
        onComplete={onComplete}
        onCancel={onCancel}
        onFetchError={onFetchError}
      />
    )
  }
}
